import { useMemo } from 'react';
import { sanitizeRichHtml } from '@/lib/richText';

interface Props {
  title: string;
  description: string;
}

const CourseDescription = ({ title, description }: Props) => {
  const richDescription = useMemo(() => sanitizeRichHtml(description), [description]);

  if (!description?.trim()) {
    return null;
  }

  return (
    <section id="section-description" className="scroll-mt-24">
      <div className="bg-white border border-slate-200 rounded-2xl p-6 sm:p-7 shadow-[0_12px_36px_-24px_rgba(15,23,42,0.4)]">
        <div className="flex items-center gap-2 mb-4">
          <div className="w-1 h-5 rounded-full bg-violet-500" />
          <h2 className="text-xl font-bold text-[#0A1628]">課程介紹</h2>
        </div>

        <p className="text-xs font-semibold uppercase tracking-[0.16em] text-slate-400 mb-3">
          {title}
        </p>

        <div
          className="course-rich-content text-slate-600 text-[15px] leading-7 max-w-none"
          dangerouslySetInnerHTML={{ __html: richDescription }}
        />
      </div>
    </section>
  );
};

export default CourseDescription;
